export function isOnlyObject(variable) {
  return variable !== undefined && variable !== null && variable.constructor === Object;
}
export function renameKeys(obj, newKeys) {
  // @ts-ignore
  const keyValues = Object.keys(obj).map(key => {
    // @ts-ignore
    const newKey = newKeys[key] || key;

    // @ts-ignore
    return {
      [newKey]: obj[key]
    };
  });

  // @ts-ignore
  return Object.assign({}, ...keyValues);
}
export function deepObjectToArray() {
  let transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : id => id;
  let obj = arguments.length > 1 ? arguments[1] : undefined;
  const result = [];
  function _transform(obj) {
    let path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        path.push(key);
        if (!isOnlyObject(value)) {
          result.push(transformer(key, value, path));
        } else {
          _transform(value, path);
        }
      }
    }
  }
  _transform(obj);
  return result;
}
export function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}